import React, { useEffect, useState } from 'react';
import { Switch, Route, NavLink } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import TvProgramHome from './tv_program_home';
import TvProgramIntro from './tv_program_intro';
import CommonProgramVod from '../common/common_program_vod';
import CommonProgramBoard from '../common/common_program_board';
import CommonProgramBoardView from '../common/common_program_board_view';
import NavData from '@/config/data/nav/nav_data.json';
import { programMenuList, tvProgramDetail, programBoardList } from '@/network/apis/apiUri';
import useAxios from '@/network/useAxios';
import NotFound from '../../not_found';
import { TvProgramEpisodeDetail, TvProgramVodDetail } from './components';
import '../tv/css/tv_program.scss';
import ProgramPhotoGallery from '@/components/photo-gallery';

function TvProgram(props) {
  const { mode, history, location } = props;

  const programId = location.pathname.split('/')[2];

  const [subLocation, setSubLocation] = useState(location.pathname);
  const [tvParameter, setTvParameter] = useState({
    program_id: 0,
    lan_code: mode,
  });

  const [homeId, setHomeId] = useState();

  const [detailItem, detailRefetch] = useAxios(tvProgramDetail, [], {}, false);
  const [menuListItem, menuListRefetch] = useAxios(programMenuList, [], {}, false);
  const [boardDetailItem, boardDetailRefetch] = useAxios(programBoardList, [], {}, false);
  const { data } = menuListItem;
  const { data: detailData } = detailItem;
  const { data: boardDetailData } = boardDetailItem;

  useEffect(() => {
    const from = new URLSearchParams(location.search).get('from');
    if (data?.item && from === 'vod') {
      let targetType = data.item.find((v) => {
        return v.type === 'vod' && v.is_open_allow && v.is_use_allow;
      });
      if (!targetType) {
        targetType = data.item.find((v) => {
          return v.type === 'episode' && v.is_open_allow && v.is_use_allow;
        });
      }
      const type = targetType?.type;
      const targetSubUrl = type === 'vod' ? 'vod' : type === 'episode' ? 'archive' : '';
      const linkToUrl = `${NavData['TV_MAIN'].path}/${programId}/${targetSubUrl}/${targetType?.board_id}`;
      if (targetType && targetSubUrl && targetType?.board_id) {
        history.replace(linkToUrl);
      }
    }
  }, [data, location]);

  useEffect(() => {
    setTvParameter({
      program_id: location.pathname.split('/')[2],
      lan_code: mode,
    });
    setSubLocation(location.pathname);
  }, [programId]);

  useEffect(() => {
    if (programId && tvParameter.program_id) {
      menuListRefetch(tvParameter);
      detailRefetch(tvParameter);
    }
  }, [tvParameter]);

  useEffect(() => {
    if (data) {
      setHomeId(data?.item?.filter((v) => v.type === 'program_home')[0].board_id);
    }
  }, [data]);

  useEffect(() => {
    if (homeId) {
      boardDetailRefetch({
        board_id: homeId,
        lan_code: mode,
        reg_order: 'desc',
        page_info: {
          row_count: 2,
          number: 0,
        },
      });
    }
  }, [homeId]);

  const [isVideoView, setIsVideoView] = useState(true);

  useEffect(() => {
    const isArchiveView = subLocation.split('/')[3] === 'archive' && /((id=)|(board=)])/.test(location.search);
    const isVodView = subLocation.split('/')[3] === 'vod' && /((id=)|(board=)])/.test(location.search);

    setIsVideoView(isArchiveView || isVodView);
  }, [location, subLocation]);

  return (
    <div id="tvProgram" className="tvProgram">
      <Helmet>
        <title>{`${detailData?.title?.[0]?.text} - TV | Arirang`}</title>
      </Helmet>
      {!detailItem?.data?.property?.is_teaser_allow ? (
        <>
          <section className={`tvProgram_section thumb sub ${isVideoView && 'archive-mode'}`}>
            <img
              className="thumb_img"
              src={detailItem.data && detailItem?.data?.image[3]?.url}
              alt={detailItem.data && detailItem.data.title[0].text}
            />
          </section>
          <section className={`tvProgram_section nav ${isVideoView ? 'style_title' : ''}`}>
            {isVideoView ? <h3 className="nav_title">{detailItem?.data?.title[0].text}</h3> : <></>}
            <ul className="nav_listWrap">
              {data?.item.map((v) => {
                let linkToUrl = '';
                let isExact = true;
                if (v.type === 'program_home') {
                  linkToUrl = `${NavData['TV_MAIN'].path}/${programId}`;
                } else if (v.type === 'program_board') {
                  linkToUrl = `${NavData['TV_MAIN'].path}/${programId}/board/${v.board_id}`;
                  isExact = false;
                } else if (v.type === 'episode') {
                  linkToUrl = `${NavData['TV_MAIN'].path}/${programId}/archive/${v.board_id}`;
                  isExact = false;
                } else if (v.type === 'vod') {
                  linkToUrl = `${NavData['TV_MAIN'].path}/${programId}/vod/${v.board_id}`;
                  isExact = false;
                } else if (v.type === 'host_introduction') {
                  linkToUrl = `${NavData['TV_MAIN'].path}/${programId}/intro/${v.board_id}`;
                } else if (v.type === 'program_photo') {
                  linkToUrl = `${NavData['TV_MAIN'].path}/${programId}/photogallery/${v.board_id}`;
                }
                if (v.is_open_allow) {
                  return (
                    <li className="list" key={v.board_id}>
                      <NavLink
                        exact={isExact}
                        to={linkToUrl}
                        className={`link${
                          location.pathname.split('/')[3] === (v.type === 'episode' ? 'archive' : v.type)
                            ? ' active'
                            : ''
                        }`}
                      >
                        {v.title}
                      </NavLink>
                    </li>
                  );
                }
                return null;
              })}
            </ul>
          </section>
          <Switch>
            <Route
              exact
              path={NavData['TV_PROGRAM'].path}
              render={() => (
                <TvProgramHome
                  mode={mode}
                  subLocation={subLocation}
                  setSubLocation={setSubLocation}
                  programData={boardDetailItem.error ? detailData : boardDetailItem.data && detailData}
                  title={menuListItem}
                  detailData={boardDetailData}
                />
              )}
            />

            <Route
              exact
              path={NavData['TV_PROGRAM_INTRO'].path}
              render={() => (
                <TvProgramIntro
                  mode={mode}
                  subLocation={subLocation}
                  setSubLocation={setSubLocation}
                  title={menuListItem}
                />
              )}
            />

            <Route
              exact
              path={NavData['TV_PROGRAM_ARCHIVE'].path}
              render={() => (
                <CommonProgramVod
                  mode={mode}
                  subLocation={subLocation}
                  setSubLocation={setSubLocation}
                  title={menuListItem}
                />
              )}
            />
            <Route
              exact
              path={NavData['TV_PROGRAM_VOD'].path}
              render={() => (
                <CommonProgramVod
                  mode={mode}
                  subLocation={subLocation}
                  setSubLocation={setSubLocation}
                  title={menuListItem}
                />
              )}
            />
            <Route exact path={NavData['TV_PROGRAM_ARCHIVE_VIEW'].path} component={TvProgramEpisodeDetail} />
            <Route exact path={NavData['TV_PROGRAM_VOD_VIEW'].path} component={TvProgramVodDetail} />
            <Route
              exact
              path={NavData['TV_PROGRAM_BOARD'].path}
              render={() => (
                <CommonProgramBoard
                  subLocation={subLocation}
                  mode={mode}
                  setSubLocation={setSubLocation}
                  search={false}
                  title={menuListItem}
                />
              )}
            />
            <Route
              exact
              path={NavData['TV_PROGRAM_BOARD_VIEW'].path}
              render={() => (
                <CommonProgramBoardView
                  subLocation={subLocation}
                  mode={mode}
                  setSubLocation={setSubLocation}
                  title={menuListItem}
                  titleStyle={0}
                />
              )}
            />

            <Route
              exact
              path={NavData['TV_PROGRAM_PHOTOGALLERY'].path}
              render={() => <ProgramPhotoGallery mode={mode} history={history} setSubLocation={setSubLocation} />}
            />

            <Route
              exact
              path={NavData['TV_PROGRAM_ANNOUNCEMENT'].path}
              render={() => (
                <CommonProgramBoard
                  subLocation={subLocation}
                  mode={mode}
                  setSubLocation={setSubLocation}
                  search={true}
                  title={'Announcement'}
                />
              )}
            />
            <Route
              exact
              path={NavData['TV_PROGRAM_ANNOUNCEMENT_VIEW'].path}
              render={() => (
                <CommonProgramBoardView
                  subLocation={subLocation}
                  mode={mode}
                  setSubLocation={setSubLocation}
                  title={'Announcement'}
                  titleStyle={0}
                />
              )}
            />

            <Route component={NotFound} />
          </Switch>
        </>
      ) : (
        <section className="tvProgram_section thumb teaser">
          <img
            className="thumb_img"
            src={detailItem.data && detailItem?.data?.image[5]?.url}
            alt={detailItem.data && detailItem.data.title[0].text}
          />
        </section>
      )}
    </div>
  );
}

export default TvProgram;
